(function () {
  if (window.__edDragonGateUsf && window.__edDgReady) return;
  var FALLBACK_HANDLES = [
    "ta1371",
    "tp6502",
    "cl1114",
    "ta2556",
    "en2002",
    "pb6003",
    "pb6002",
    "pb6001",
    "veltuff-papkasse-lille",
    "papkasse",
    "veltuff-box-medium-gron",
    "bx0500",
    "bx0501",
    "bx0502",
    "bx0503",
    "bx0504",
    "bx0505",
    "bx0506",
    "bx0507",
    "bx0508",
    "bx0510",
    "bx0514"
  ];
  var hideHandles = {};
  var hideIds = {};
  var hideCollections = {};
  var showHandles = {};
  var showIds = {};
  var hideAllProducts = false;
  var mapsReady = false;
  var applyingUsf = false;
  var visitorReady = false;

  function looksLikeJson(value) {
    if (value == null) return false;
    if (typeof value === "object") return true;
    if (typeof value !== "string") return false;
    var text = String(value).replace(/^\uFEFF/, "").trim();
    if (!text) return false;
    if (/^\s*function\b/.test(text)) return false;
    var first = text.charAt(0);
    if (first === "{" || first === "[" || first === '"') return true;
    if (first === "-" || (first >= "0" && first <= "9")) return true;
    return text === "true" || text === "false" || text === "null";
  }

  function safeJsonParse(value, fallback) {
    if (value == null || value === "") return fallback;
    if (typeof value !== "string") return value;
    var text = String(value).replace(/^\uFEFF/, "").trim();
    if (!text || !looksLikeJson(text)) return fallback;
    try {
      return JSON.parse(text);
    } catch (e) {
      return fallback;
    }
  }

  function sanitizeUsfStorage(storage) {
    var stores = [];
    if (storage) {
      stores.push(storage);
    } else {
      try {
        stores.push(sessionStorage);
      } catch (e) {}
      try {
        stores.push(localStorage);
      } catch (e2) {}
    }
    var removed = 0;
    for (var s = 0; s < stores.length; s++) {
      var store = stores[s];
      if (!store) continue;
      var keys = [];
      try {
        for (var i = 0; i < store.length; i++) {
          var key = store.key(i);
          if (key) keys.push(key);
        }
      } catch (e3) {
        continue;
      }
      for (var k = 0; k < keys.length; k++) {
        var name = keys[k];
        if (!/^usf/i.test(name) && name !== "dragonGateUnlocks") continue;
        var raw;
        try {
          raw = store.getItem(name);
        } catch (e4) {
          continue;
        }
        if (typeof raw !== "string") continue;
        if (looksLikeJson(raw) && (safeJsonParse(raw, null) != null || raw.trim() === "null")) continue;
        try {
          store.removeItem(name);
          removed += 1;
        } catch (e5) {}
      }
    }
    return removed;
  }

  function norm(v) {
    return String(v || "")
      .toLowerCase()
      .trim();
  }

  function nid(v) {
    if (v == null || v === "") return "";
    var s = String(v);
    return s.indexOf("/") >= 0 ? s.split("/").pop() : s;
  }

  function rememberHandle(handle) {
    var key = norm(handle);
    if (!key) return;
    hideHandles[key] = true;
    hideHandles[handle] = true;
  }

  function rememberId(id) {
    var pid = nid(id);
    if (pid) hideIds[pid] = true;
  }

  function rememberCollection(handle) {
    var key = norm(handle);
    if (key) hideCollections[key] = true;
  }

  function rememberShowHandle(handle) {
    var key = norm(handle);
    if (key) showHandles[key] = true;
  }

  function rememberShowId(id) {
    var pid = nid(id);
    if (pid) showIds[pid] = true;
  }

  function resetHideSets() {
    hideHandles = {};
    hideIds = {};
    hideCollections = {};
    showHandles = {};
    showIds = {};
    hideAllProducts = false;
  }

  function asIdList() {
    var out = [];
    for (var a = 0; a < arguments.length; a++) {
      var value = arguments[a];
      if (!value) continue;
      if (!Array.isArray(value) && typeof value === "object") value = Object.keys(value);
      if (!Array.isArray(value)) continue;
      for (var i = 0; i < value.length; i++) {
        if (value[i] != null && value[i] !== "") out.push(value[i]);
      }
    }
    return out;
  }

  function applyHideList(list, opts) {
    opts = opts || {};
    if (!list) return;
    if (opts.replace) resetHideSets();
    hideAllProducts = Boolean(list.hideAllProducts || list.allProducts);
    var handles = asIdList(list.hideProductHandles, list.handles, list.productHandles);
    var ids = asIdList(list.hideProductIds, list.ids, list.productIds);
    var collections = asIdList(list.hideCollectionHandles, list.collectionHandles);
    var collectionIds = asIdList(list.hideCollectionIds, list.collectionIds);
    var shownHandles = asIdList(list.showProductHandles, list.showHandles);
    var shownIds = asIdList(list.showProductIds);
    var shownCols = asIdList(list.showCollectionIds, list.showCollectionHandles);
    if (!handles.length && list.handles && typeof list.handles === "object" && !Array.isArray(list.handles)) {
      handles = Object.keys(list.handles);
      Object.keys(list.handles).forEach(function (key) {
        var entry = list.handles[key];
        if (entry && typeof entry === "object" && entry.id) ids.push(entry.id);
      });
    }
    for (var i = 0; i < handles.length; i++) rememberHandle(handles[i]);
    for (var j = 0; j < ids.length; j++) rememberId(ids[j]);
    for (var c = 0; c < collections.length; c++) rememberCollection(collections[c]);
    for (var d = 0; d < collectionIds.length; d++) rememberCollection(collectionIds[d]);
    for (var s = 0; s < shownHandles.length; s++) rememberShowHandle(shownHandles[s]);
    for (var t = 0; t < shownIds.length; t++) rememberShowId(shownIds[t]);
    for (var u = 0; u < shownCols.length; u++) rememberShowId(shownCols[u]);
  }

  function currentHideHasData() {
    return !!(
      Object.keys(hideHandles).length ||
      Object.keys(hideIds).length ||
      Object.keys(hideCollections).length ||
      hideAllProducts
    );
  }

  function isGuestVisitor() {
    return !(window._edCustomer && window._edCustomer.loggedIn);
  }

  function applyFallbackHandles() {
    if (window._edCustomer && window._edCustomer.loggedIn) return;
    for (var i = 0; i < FALLBACK_HANDLES.length; i++) rememberHandle(FALLBACK_HANDLES[i]);
  }

  function applyVisitorOrFallback(visitor) {
    if (hideListHasItems(visitor)) {
      applyHideList(visitor, { replace: true });
      return;
    }
    if (!currentHideHasData()) applyFallbackHandles();
  }

  function proxyTimeoutMs() {
    var n = Number(window.__edDgProxyTimeoutMs);
    return n > 0 ? n : 4000;
  }

  function timedFetch(url, init) {
    var ms = proxyTimeoutMs();
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error("timeout"));
      }, ms);
      fetch(url, init).then(
        function (response) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(response);
        },
        function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(err);
        }
      );
    });
  }

  function handleFromUrl(url) {
    if (!url) return "";
    var s = String(url);
    var i = s.indexOf("/products/");
    if (i < 0) return "";
    try {
      return decodeURIComponent(s.slice(i + 10).split(/[?#]/)[0] || "");
    } catch (e) {
      return s.slice(i + 10).split(/[?#]/)[0] || "";
    }
  }

  function productHandle(p) {
    if (!p) return "";
    if (typeof p === "string") return handleFromUrl(p) || p;
    return (
      p.handle ||
      p.urlName ||
      p.url_name ||
      p.urlHandle ||
      handleFromUrl(p.url || p.productUrl || p.link || "") ||
      ""
    );
  }

  function productCollections(p) {
    var out = [];
    if (!p) return out;
    var raw = p.collections || p.collectionList || p.collectionIds || p.collection_ids || [];
    if (typeof raw === "string") raw = [raw];
    if (!Array.isArray(raw)) return out;
    for (var i = 0; i < raw.length; i++) {
      var item = raw[i];
      if (item == null) continue;
      if (typeof item === "string" || typeof item === "number") {
        out.push(norm(item));
        out.push(nid(item));
        continue;
      }
      out.push(norm(item.handle || item.urlName || item.url_name || item.urlHandle || ""));
      if (item.id) out.push(nid(item.id));
    }
    return out.filter(Boolean);
  }

  function listLength(value) {
    if (!value) return 0;
    if (Array.isArray(value)) return value.length;
    if (typeof value === "object") return Object.keys(value).length;
    return 0;
  }

  function hideListHasItems(list) {
    if (!list || typeof list !== "object") return false;
    if (list.hideAllProducts || list.allProducts) return true;
    return (
      listLength(list.hideProductIds || list.ids || list.productIds) > 0 ||
      listLength(list.hideCollectionIds || list.collectionIds || list.hideCollectionHandles || list.collectionHandles) > 0 ||
      listLength(list.hideProductHandles || list.handles || list.productHandles) > 0
    );
  }

  function mergeJsonMap() {
    var jsonEl = document.getElementById("ed-dragon-gate-restricted-products");
    if (!jsonEl) return false;
    try {
      var extra = safeJsonParse(jsonEl.textContent, null);
      if (!extra || typeof extra !== "object") return false;
      if (Array.isArray(extra)) {
        if (!extra.length) return false;
        applyHideList({ handles: extra });
        return true;
      }
      if (!hideListHasItems(extra)) return false;
      if (
        extra.hideProductIds ||
        extra.ids ||
        extra.hideCollectionIds ||
        extra.collectionIds ||
        extra.handles ||
        extra.collectionHandles ||
        extra.hideProductHandles
      ) {
        applyHideList(extra);
        return true;
      }
      applyHideList({ handles: extra });
      return true;
    } catch (e) {
      return false;
    }
  }

  function mergeAppRestricted() {
    var el = document.querySelector("[data-dragon-gate-restricted]");
    if (!el) return false;
    try {
      var payload = safeJsonParse(el.textContent || "{}", {});
      if (!hideListHasItems(payload)) return false;
      applyHideList(payload);
      return true;
    } catch (e) {
      return false;
    }
  }

  function isShownId(id) {
    var pid = nid(id);
    return !!(pid && showIds[pid]);
  }

  function isHiddenHandle(handle) {
    if (showHandles[norm(handle)]) return false;
    if (hideAllProducts) return true;
    if (!handle) return false;
    return !!(hideHandles[handle] || hideHandles[norm(handle)]);
  }

  function isHiddenId(id) {
    var pid = nid(id);
    if (!pid) return false;
    if (showIds[pid]) return false;
    if (hideAllProducts) return true;
    return !!hideIds[pid];
  }

  function isHiddenCollection(product) {
    var cols = productCollections(product);
    for (var i = 0; i < cols.length; i++) {
      if (showIds[nid(cols[i])] || showIds[norm(cols[i])]) return false;
      if (hideCollections[cols[i]] || hideCollections[nid(cols[i])]) return true;
    }
    return false;
  }

  function currentCollectionHidden() {
    var col = window.__dragonGateCollection;
    if (!col) return false;
    if (isShownId(col.id)) return false;
    return !!(hideCollections[norm(col.handle)] || hideCollections[norm(col.id)] || hideCollections[nid(col.id)]);
  }

  function handleFromCollectionUrl(url) {
    if (!url) return "";
    var s = String(url);
    var i = s.indexOf("/collections/");
    if (i < 0) return "";
    try {
      return decodeURIComponent(s.slice(i + 13).split(/[?#]/)[0] || "");
    } catch (e) {
      return s.slice(i + 13).split(/[?#]/)[0] || "";
    }
  }

  function collectionHandleOf(col) {
    if (!col) return "";
    if (typeof col === "string" || typeof col === "number") return String(col);
    return (
      col.handle ||
      col.urlName ||
      col.url_name ||
      col.urlHandle ||
      handleFromCollectionUrl(col.url || col.link || "") ||
      ""
    );
  }

  function collectionIdOf(col) {
    if (!col) return "";
    if (typeof col === "string" || typeof col === "number") return nid(col);
    return nid(col.id || col.collectionId || col.collection_id || "");
  }

  function isAllowedCollection(col) {
    if (!col) return true;
    var handle = collectionHandleOf(col);
    var id = collectionIdOf(col);
    if (id && isShownId(id)) return true;
    if (handle && (showHandles[norm(handle)] || showIds[norm(handle)] || showIds[nid(handle)])) return true;
    if (id && (hideCollections[id] || hideCollections[nid(id)] || hideCollections[norm(id)])) return false;
    if (handle && (hideCollections[norm(handle)] || hideCollections[handle])) return false;
    return true;
  }

  function filterCollections(list) {
    if (!list || !list.length) return list;
    return list.filter(function (col) {
      return isAllowedCollection(col);
    });
  }

  function suggestionText(value) {
    if (value == null) return "";
    if (typeof value === "string") return value;
    return value.title || value.text || value.query || value.term || value.q || "";
  }

  function foldSearchText(value) {
    return norm(value)
      .replace(/[æä]/g, "ae")
      .replace(/[øö]/g, "o")
      .replace(/[å]/g, "a")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function searchTokens(value) {
    return foldSearchText(value)
      .split(" ")
      .filter(function (token) {
        return token.length > 2;
      });
  }

  function itemSku(product) {
    if (!product) return "";
    if (product.sku) return product.sku;
    var variant = product.selectedVariant || (product.variants && product.variants[0]);
    return (variant && variant.sku) || "";
  }

  function textMatchesProduct(text, product) {
    var query = foldSearchText(text);
    if (!query || !product) return false;
    var title = foldSearchText(product.title || product.name || "");
    var handle = foldSearchText(productHandle(product)).replace(/ /g, " ");
    var sku = foldSearchText(itemSku(product));
    if (title && (title === query || title.indexOf(query) !== -1 || query.indexOf(title) !== -1)) return true;
    if (handle && (handle === query || handle.replace(/-/g, " ") === query)) return true;
    if (sku && sku === query) return true;
    var queryTokens = searchTokens(text);
    var titleTokens = searchTokens(title);
    if (!queryTokens.length || !titleTokens.length) return false;
    var map = {};
    for (var i = 0; i < titleTokens.length; i++) map[titleTokens[i]] = true;
    var hits = 0;
    for (var j = 0; j < queryTokens.length; j++) {
      if (map[queryTokens[j]]) hits += 1;
    }
    return hits >= Math.min(2, queryTokens.length) || hits === queryTokens.length;
  }

  function textMatchesCollection(text, col) {
    var query = foldSearchText(text);
    if (!query || !col) return false;
    var title = foldSearchText(col.title || col.name || "");
    var handle = foldSearchText(collectionHandleOf(col));
    if (title && (title === query || title.indexOf(query) !== -1 || query.indexOf(title) !== -1)) return true;
    return !!(handle && handle === query);
  }

  function suggestionAllowed(value, hiddenItems, visibleItems, hiddenCollections) {
    var text = suggestionText(value);
    if (!text) return true;
    var matchesVisible = false;
    var matchesHidden = false;
    var i;
    if (visibleItems) {
      for (i = 0; i < visibleItems.length; i++) {
        if (textMatchesProduct(text, visibleItems[i])) {
          matchesVisible = true;
          break;
        }
      }
    }
    if (hiddenItems) {
      for (i = 0; i < hiddenItems.length; i++) {
        if (textMatchesProduct(text, hiddenItems[i])) {
          matchesHidden = true;
          break;
        }
      }
    }
    if (hiddenCollections) {
      for (i = 0; i < hiddenCollections.length; i++) {
        if (textMatchesCollection(text, hiddenCollections[i])) {
          matchesHidden = true;
        }
      }
    }
    if (matchesHidden && !matchesVisible) return false;
    return true;
  }

  function filterSuggestions(list, hiddenItems, visibleItems, hiddenCollections) {
    if (!list || !list.length) return list;
    return list.filter(function (value) {
      return suggestionAllowed(value, hiddenItems, visibleItems, hiddenCollections);
    });
  }

  function productIdOf(product) {
    if (!product) return "";
    return nid(product.id || product.productId || product.product_id || product.pid || "");
  }

  function isFavoritesPage() {
    return (
      window.__edFavoritesPage === true ||
      window.__edFavoritesPage === "true" ||
      window.__edSpecialProductsPage === true ||
      window.__edSpecialProductsPage === "true"
    );
  }

  function companyWishlistIds() {
    var ids = window.__edCompanyWishlistProductIds;
    if ((!ids || !ids.length) && window.__edCompanyFavorites && window.__edCompanyFavorites.productIds) {
      ids = window.__edCompanyFavorites.productIds;
    }
    if (!ids) return [];
    return Array.isArray(ids) ? ids : [ids];
  }

  function isCompanyWishlistProduct(product) {
    var pid = productIdOf(product);
    if (!pid) return false;
    var ids = companyWishlistIds();
    for (var i = 0; i < ids.length; i++) {
      if (nid(ids[i]) === pid) return true;
    }
    return false;
  }

  function isExplicitlyShown(handle, product) {
    var pid = productIdOf(product);
    if (pid && isShownId(pid)) return true;
    if (handle && showHandles[norm(handle)]) return true;
    var cols = productCollections(product);
    for (var i = 0; i < cols.length; i++) {
      if (showIds[nid(cols[i])] || showIds[norm(cols[i])]) return true;
    }
    return false;
  }

  function isAllowed(handle, product, opts) {
    opts = opts || {};
    var pid = productIdOf(product);
    if (isExplicitlyShown(handle, product)) return true;
    if (isFavoritesPage()) {
      if (pid && isHiddenId(pid)) return false;
      if (isHiddenHandle(handle)) return false;
      if (product && isHiddenCollection(product) && !isCompanyWishlistProduct(product)) return false;
      return isCompanyWishlistProduct(product);
    }
    if (!opts.ignorePageCollection && currentCollectionHidden()) return false;
    if (pid && isHiddenId(pid)) return false;
    if (isHiddenHandle(handle)) return false;
    if (product && isHiddenCollection(product)) return false;
    return true;
  }

  function isUsfSearchUrl(url) {
    if (!url) return false;
    var s = String(url);
    var path = s.split("?")[0];
    if (/instantsearch/i.test(s)) return true;
    if (/searchSvc/i.test(s)) return true;
    if (/usf/i.test(s) && /\/search(\/|$)/i.test(path)) return true;
    return false;
  }

  function applyToUsf() {
    if (applyingUsf) return;
    applyingUsf = true;
    try {
      scrubDom(document);
    } finally {
      applyingUsf = false;
    }
  }

  function fetchCollectionPage(handle, page) {
    return fetch("/collections/" + encodeURIComponent(handle) + "/products.json?limit=250&page=" + page, {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        return response.ok ? response.json() : { products: [] };
      })
      .then(function (data) {
        return (data && data.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function collectionHandleList() {
    return Object.keys(hideCollections).filter(function (key) {
      return key && !/^\d+$/.test(key);
    });
  }

  function loadCollectionMaps() {
    if (window.__edDgMapsLoading) return window.__edDgMapsLoading;
    var handles = collectionHandleList();
    if (!handles.length) {
      mapsReady = true;
      window.__edDgMapsLoading = Promise.resolve();
      return window.__edDgMapsLoading;
    }
    function loadHandle(handle) {
      function page(n) {
        return fetchCollectionPage(handle, n).then(function (products) {
          for (var i = 0; i < products.length; i++) {
            rememberHandle(products[i].handle);
            rememberId(products[i].id);
          }
          if (products.length >= 250) return page(n + 1);
        });
      }
      return page(1);
    }
    window.__edDgMapsLoading = Promise.all(handles.map(loadHandle)).then(function () {
      mapsReady = true;
      applyToUsf();
    });
    return window.__edDgMapsLoading;
  }

  function reloadCollectionMaps() {
    window.__edDgMapsLoading = null;
    mapsReady = false;
    return loadCollectionMaps();
  }

  function usfResultItems() {
    var items = [];
    if (window.usf && usf.search && usf.search.result && usf.search.result.items) {
      items = items.concat(usf.search.result.items);
    }
    if (window.usf && usf.instantSearch && usf.instantSearch.result && usf.instantSearch.result.items) {
      items = items.concat(usf.instantSearch.result.items);
    }
    return items;
  }

  function usfResultCollections() {
    var cols = [];
    if (window.usf && usf.instantSearch && usf.instantSearch.result && usf.instantSearch.result.collections) {
      cols = cols.concat(usf.instantSearch.result.collections);
    }
    if (window.usf && usf.search && usf.search.result && usf.search.result.collections) {
      cols = cols.concat(usf.search.result.collections);
    }
    if (window.usf && usf.search && usf.search.result && usf.search.result.extra && usf.search.result.extra.collections) {
      cols = cols.concat(usf.search.result.extra.collections);
    }
    return cols;
  }

  function nodePlainText(node) {
    return String((node && node.textContent) || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function usfItemForNode(node) {
    var pid =
      node.getAttribute("data-usf-pid") ||
      node.getAttribute("data-product-id") ||
      node.getAttribute("product-selector");
    var items = usfResultItems();
    var i;
    if (pid) {
      for (i = 0; i < items.length; i++) {
        if (String(items[i].id) === String(pid) || String(items[i].productId) === String(pid)) {
          return items[i];
        }
      }
    }
    var titleEl = node.querySelector(".usf-title, .card__heading a, .card__heading, .full-unstyled-link");
    var title = nodePlainText(titleEl);
    var sku = nodePlainText(node.querySelector(".usf-vendor, .product__vendor"));
    for (i = 0; i < items.length; i++) {
      if (sku && foldSearchText(itemSku(items[i])) === foldSearchText(sku)) return items[i];
      if (title && foldSearchText(items[i].title || "") === foldSearchText(title)) return items[i];
    }
    if (title || sku) return { title: title, sku: sku };
    return null;
  }

  function collectionForNode(node) {
    var link = node.matches && node.matches("a[href*='/collections/']")
      ? node
      : node.querySelector
        ? node.querySelector("a[href*='/collections/']")
        : null;
    var href = link ? link.getAttribute("href") || link.href || "" : "";
    var handle = "";
    var idx = href.indexOf("/collections/");
    if (idx >= 0) handle = href.slice(idx + 13).split(/[?#]/)[0];
    var title = nodePlainText(node.querySelector(".predictive-search__item-heading, .ed-search-collection-tags__link") || node);
    var cols = usfResultCollections();
    for (var i = 0; i < cols.length; i++) {
      if (handle && norm(collectionHandleOf(cols[i])) === norm(handle)) return cols[i];
      if (title && foldSearchText(cols[i].title || "") === foldSearchText(title)) return cols[i];
    }
    return { title: title, handle: handle, urlName: handle };
  }

  function isCollectionNode(node) {
    if (!node || !node.classList) return false;
    if (node.classList.contains("ed-search-collection-tags__item")) return true;
    if (node.closest && node.closest(".usf-is-collections") && node.classList.contains("usf-is-match")) return true;
    if (node.classList.contains("predictive-search__list-item")) {
      var hasCol = node.querySelector && node.querySelector("a[href*='/collections/']");
      var hasProd = node.querySelector && node.querySelector("a[href*='/products/']");
      return !!(hasCol && !hasProd);
    }
    return false;
  }

  function isSuggestionNode(node) {
    if (!node || !node.classList) return false;
    if (node.closest && node.closest(".usf-is-suggestions") && node.classList.contains("usf-is-match")) return true;
    if (node.classList.contains("predictive-search__list-item") && node.querySelector(".predictive-search__item-query-result")) {
      return true;
    }
    return false;
  }

  function filterItems(items) {
    if (!items || !items.length) return items;
    return items.filter(function (p) {
      return isAllowed(productHandle(p), p);
    });
  }

  function filterPayload(data) {
    if (!data || typeof data !== "object") return data;
    if (data.data && typeof data.data === "object" && !Array.isArray(data.data) && !data.items) {
      filterPayload(data.data);
      return data;
    }
    var hiddenItems = [];
    var hiddenCollections = [];
    if (data.items) {
      try {
        if (isFavoritesPage() && typeof window.__edMergeCompanyFavorites === "function") {
          data.items = window.__edMergeCompanyFavorites(data.items);
        }
      } catch (e) {}
      var before = data.items.length;
      var kept = [];
      for (var i = 0; i < data.items.length; i++) {
        var item = data.items[i];
        if (isAllowed(productHandle(item), item)) kept.push(item);
        else hiddenItems.push(item);
      }
      data.items = kept;
      if (typeof data.total === "number") {
        data.total = Math.max(0, data.total - (before - kept.length));
      }
    }
    if (data.collections) {
      var nextCollections = [];
      for (var c = 0; c < data.collections.length; c++) {
        var col = data.collections[c];
        if (isAllowedCollection(col)) nextCollections.push(col);
        else hiddenCollections.push(col);
      }
      data.collections = nextCollections;
    }
    if (data.extra && data.extra.collections) {
      data.extra.collections = filterCollections(data.extra.collections);
    }
    if (data.suggestions) {
      data.suggestions = filterSuggestions(data.suggestions, hiddenItems, data.items, hiddenCollections);
    }
    if (data.popularSearch) {
      data.popularSearch = filterSuggestions(data.popularSearch, hiddenItems, data.items, hiddenCollections);
    }
    return data;
  }

  function hideNode(node) {
    if (node.style.display !== "none") node.style.display = "none";
    if (!node.hasAttribute("data-ed-dg-hidden")) node.setAttribute("data-ed-dg-hidden", "1");
  }

  function showCheckedNode(node) {
    if (node.hasAttribute("data-ed-dg-hidden")) {
      node.removeAttribute("data-ed-dg-hidden");
      node.style.display = "";
    }
    node.setAttribute("data-ed-dg-checked", "1");
  }

  function scrubDom(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    var nodes = root.querySelectorAll(
      ".usf-sr-product, .ed-usf-list-row, .ed-usf-grid-card, .usf-grid__item, .usf-is-product, .usf-is-product-card, .usf-is-horizontal-product-card, .usf-is-collections .usf-is-match, .usf-is-suggestions .usf-is-match, .predictive-search__list-item, .ed-search-collection-tags__item, .dragon-gate-hidden"
    );
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var inSavedList =
        node.closest &&
        node.closest("[data-ed-wishlist-grid], [data-ed-saved-box]");
      var inSpecialList = node.closest && node.closest("[data-ed-special-grid], [data-ed-special-box]");
      if (node.classList && node.classList.contains("dragon-gate-hidden")) {
        hideNode(node);
        continue;
      }
      if (node.getAttribute("data-ed-dg-checked") === "1" && mapsReady && visitorReady) continue;
      if (isCollectionNode(node)) {
        if (!isAllowedCollection(collectionForNode(node))) hideNode(node);
        else if (mapsReady || visitorReady) showCheckedNode(node);
        continue;
      }
      if (isSuggestionNode(node)) {
        var suggestion = nodePlainText(node);
        var visibleItems = usfResultItems();
        var hiddenCols = [];
        var allCols = usfResultCollections();
        for (var h = 0; h < allCols.length; h++) {
          if (!isAllowedCollection(allCols[h])) hiddenCols.push(allCols[h]);
        }
        if (!suggestionAllowed(suggestion, null, visibleItems, hiddenCols)) hideNode(node);
        else if (mapsReady || visitorReady) showCheckedNode(node);
        continue;
      }
      var pid =
        node.getAttribute("data-usf-pid") ||
        node.getAttribute("data-product-id") ||
        node.getAttribute("product-selector");
      var cid =
        node.getAttribute("data-collection-id") ||
        node.getAttribute("data-usf-collection-id");
      var item = usfItemForNode(node) || (pid ? { id: pid } : null);
      if (item && cid) {
        item.collectionIds = (item.collectionIds || item.collections || []).concat(cid);
      }
      var link = node.querySelector('a[href*="/products/"]');
      var handle = item
        ? productHandle(item)
        : handleFromUrl(link ? link.getAttribute("href") || link.href || "" : "");
      if (!handle && link) handle = handleFromUrl(link.getAttribute("href") || link.href || "");
      if (!handle) handle = node.getAttribute("data-product-handle") || "";
      if (!handle && !item) continue;
      if (!isAllowed(handle, item, { ignorePageCollection: !!(inSavedList && !inSpecialList) })) {
        hideNode(node);
      } else if ((mapsReady || visitorReady) && (handle || item)) {
        showCheckedNode(node);
      }
    }
  }

  function onUsfData(_vm, data) {
    filterPayload(data);
    setTimeout(function () {
      scrubDom(document);
    }, 0);
    setTimeout(function () {
      scrubDom(document);
    }, 50);
    if (!mapsReady) loadCollectionMaps().then(applyToUsf);
  }

  function wrapSuccess(success) {
    return function (payload) {
      if (typeof success !== "function") return;
      if (typeof payload === "function") return;
      if (typeof payload === "string" && /^\s*function\b/.test(payload)) return;
      var args = [].slice.call(arguments);
      function apply(parsed) {
        filterPayload(parsed);
        return parsed;
      }
      try {
        if (typeof payload === "string") {
          var parsed = safeJsonParse(payload, null);
          if (parsed && typeof parsed === "object") args[0] = JSON.stringify(apply(parsed));
        } else if (payload && typeof payload === "object") {
          if (payload.items) apply(payload);
          else if (payload.data) apply(payload.data);
          args[0] = JSON.stringify(payload);
        }
      } catch (e) {}
      var result = success.apply(this, args);
      if (!mapsReady) loadCollectionMaps().then(applyToUsf);
      return result;
    };
  }

  function hookXhr() {
    if (window.__edDgXhr) return;
    window.__edDgXhr = true;
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__edDgUrl = url ? String(url) : "";
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (isUsfSearchUrl(this.__edDgUrl)) {
        var xhr = this;
        var prev = this.onreadystatechange;
        this.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 400) {
            try {
              var data = safeJsonParse(xhr.responseText, null);
              if (data && typeof data === "object") {
                filterPayload(data);
                var text = JSON.stringify(data);
                Object.defineProperty(xhr, "responseText", {
                  configurable: true,
                  get: function () {
                    return text;
                  }
                });
                Object.defineProperty(xhr, "response", {
                  configurable: true,
                  get: function () {
                    return text;
                  }
                });
              }
            } catch (e) {}
          }
          if (typeof prev === "function") return prev.apply(this, arguments);
        };
      }
      return nativeSend.apply(this, arguments);
    };
  }

  function hookUsf() {
    if (!window.usf) return false;

    if (usf.event && usf.event.add && !window.__edDgUsfEvents) {
      window.__edDgUsfEvents = true;
      usf.event.add("sr_dataReceived", onUsfData);
      usf.event.add("is_dataReceived", onUsfData);
      usf.event.add("sr_updated", function () {
        if (mapsReady) applyToUsf();
        else scrubDom(document);
      });
      usf.event.add("is_updated", function () {
        if (mapsReady) applyToUsf();
        else scrubDom(document);
      });
    }

    if (usf.utils && usf.utils.send && !usf.utils.__edDgSend) {
      var nativeSend = usf.utils.send.bind(usf.utils);
      usf.utils.send = function (config, skipPlugins) {
        if (config && config.success) config.success = wrapSuccess(config.success);
        return nativeSend(config, skipPlugins);
      };
      usf.utils.__edDgSend = true;
    }

    if (usf.fetch && !usf.fetch.__edDgWrapped) {
      var nativeFetch = usf.fetch;
      var lastFull = 0;
      function wrappedFetch(e, t, r) {
        if (!r && (t == null || t === 0)) {
          var now = Date.now();
          if (lastFull && now - lastFull < 350) return;
          lastFull = now;
        }
        return nativeFetch.apply(this, arguments);
      }
      wrappedFetch.__edDgWrapped = true;
      usf.fetch = wrappedFetch;
    }

    if (mapsReady) applyToUsf();

    return !!(usf.event && usf.utils);
  }

  function hookFetch() {
    if (window.__edDgFetch) return;
    window.__edDgFetch = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      return nativeFetch(input, init).then(function (response) {
        var url = typeof input === "string" ? input : input && input.url ? input.url : "";
        if (!isUsfSearchUrl(url)) {
          return response;
        }
        var type = response.headers.get("content-type") || "";
        if (type.indexOf("json") === -1) return response;
        return response
          .clone()
          .json()
          .then(function (data) {
            if (data && typeof data === "object") filterPayload(data);
            return new Response(JSON.stringify(data), {
              status: response.status,
              statusText: response.statusText,
              headers: response.headers
            });
          })
          .catch(function () {
            return response;
          });
      });
    };
  }

  function pageContext() {
    var col = window.__dragonGateCollection || {};
    var product = window.__dragonGateProduct || {};
    return {
      productHandle: product.handle || handleFromUrl(window.location.pathname),
      collectionHandle: col.handle || "",
      productId: product.id ? nid(product.id) : undefined,
      collectionId: col.id ? nid(col.id) : undefined
    };
  }

  function parseVisitor(data) {
    if (!data || typeof data !== "object") return null;
    if (hideListHasItems(data) || data.page) return data;
    return null;
  }

  function fetchVisitorHideList() {
    var ctx = pageContext();
    var body = {
      unlockTokens: {},
      productHandle: ctx.productHandle || undefined,
      collectionHandle: ctx.collectionHandle || undefined,
      productId: ctx.productId,
      collectionId: ctx.collectionId
    };
    try {
      body.unlockTokens = safeJsonParse(sessionStorage.getItem("dragonGateUnlocks") || "{}", {});
    } catch (e) {
      body.unlockTokens = {};
    }
    return timedFetch("/apps/dragon-gate/rules", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) throw new Error("proxy");
        return response.json();
      })
      .then(function (data) {
        var visitor = parseVisitor(data);
        if (!visitor) throw new Error("proxy");
        return visitor;
      })
      .catch(function () {
        return timedFetch("/apps/dragon-gate/rules", {
          credentials: "same-origin",
          headers: { Accept: "application/json" }
        }).then(function (response) {
          if (!response.ok) throw new Error("proxy");
          return response.json();
        }).then(function (data) {
          var visitor = parseVisitor(data);
          if (!visitor) throw new Error("proxy");
          return visitor;
        });
      });
  }

  function bootHideList() {
    var hadInline = mergeJsonMap();
    var hadApp = mergeAppRestricted();
    if (!hadInline && !hadApp) applyFallbackHandles();
    if (!currentHideHasData()) applyFallbackHandles();
    loadCollectionMaps();
    return fetchVisitorHideList()
      .then(function (visitor) {
        applyVisitorOrFallback(visitor);
        visitorReady = true;
        reloadCollectionMaps();
        applyToUsf();
      })
      .catch(function () {
        if (!currentHideHasData()) applyFallbackHandles();
        visitorReady = true;
        applyToUsf();
      });
  }

  hookXhr();
  hookFetch();
  sanitizeUsfStorage();
  var bootPromise = bootHideList();

  if (!window.__edDgDisablePoll) {
    var tries = 0;
    (function wait() {
      hookUsf();
      scrubDom(document);
      tries += 1;
      if (tries < 100) setTimeout(wait, 200);
    })();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        mutations[i].addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) scrubDom(node);
        });
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    hookUsf();
    scrubDom(document);
  });
  window.addEventListener("load", function () {
    hookUsf();
    scrubDom(document);
  });

  window.__edDragonGateUsf = {
    isAllowed: function (handle, product, opts) {
      return isAllowed(handle, product, opts);
    },
    isShownId: function (id) {
      return isShownId(id);
    },
    isHiddenId: function (id) {
      return isHiddenId(id);
    },
    scrub: function () {
      scrubDom(document);
    },
    ready: bootPromise,
    _test: {
      hideListHasItems: hideListHasItems,
      mergeJsonMap: mergeJsonMap,
      applyVisitorOrFallback: applyVisitorOrFallback,
      applyFallbackHandles: applyFallbackHandles,
      applyHideList: applyHideList,
      resetHideSets: resetHideSets,
      currentHideHasData: currentHideHasData,
      isGuestVisitor: isGuestVisitor,
      FALLBACK_HANDLES: FALLBACK_HANDLES,
      safeJsonParse: safeJsonParse,
      looksLikeJson: looksLikeJson,
      sanitizeUsfStorage: sanitizeUsfStorage,
      wrapSuccess: wrapSuccess,
      filterPayload: filterPayload,
      isUsfSearchUrl: isUsfSearchUrl,
      isAllowedCollection: isAllowedCollection,
      suggestionAllowed: suggestionAllowed,
      collectionHandleOf: collectionHandleOf
    }
  };
  window.__edDgReady = true;
})();
